import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as actionCreators from "../../action-creators";
import { ReducerState, MappedActionsProps } from "../../reducer";
import * as FileService from "../../service/sfp/file-service";
import Loader from "../loader";
import { Role } from "../../constant/role";
import DragSortableList from "react-drag-sortable";
import "./style.scss";

class AideDetail extends React.Component<InjectedProps, State> {
    constructor(props: Readonly<InjectedProps>) {
        super(props);

        this.state = {
            searchVideo: "",
            uploading: false,
            submitting: false,
            loadingList: false,
            selectedFile: null,
            editIndex: null,
            updatedTitle: null,
            videoFileList: [],
            isAdmin: false,
        };
    }
    componentDidMount() {
        this.props.actions.setPageTitle("Aide");
        this.props.actions.getS3FilesList();
        let status = this.props.currentUser.roles.indexOf(Role.SuperAdmin) !== -1;
        if (status) {
            this.setState({ isAdmin: true });
        }
    }

    componentDidUpdate(prevProps: Readonly<InjectedProps>) {
        if (prevProps.s3FilesList !== this.props.s3FilesList) {
            this.setState({ videoFileList: this.props.s3FilesList });
        }
    }

    // On file select (from the pop up)
    onFileChange = (event) => {
        // Update the state
        this.setState({ selectedFile: event.target.files[0] });
    };
    // On file upload (click the upload button)
    onFileUpload = async () => {
        this.setState({ uploading: true });
        await FileService.uploadFileToS3(this.state.selectedFile)
            .then(async () => {
                this.props.actions.getS3FilesList();
                this.setState({ selectedFile: null, uploading: false });
            });
    };

    deleteVideo = async (id) => {
        //   this.props.actions.deleteFileFromS3(id);
        this.setState({ loadingList: true });
        await FileService.deleteS3File(id)
            .then(async () => {
                // this.props.actions.getS3FilesList();
                let foundIndex = this.state.videoFileList.findIndex((data) => {
                    return data.id === id;
                });
                let updatedList = [...this.state.videoFileList];
                updatedList.splice(foundIndex, 1);
                this.setState({ videoFileList: updatedList, loadingList: false });
            });
    };

    editVideoDetail = (videoDetail) => {
        let foundIndex = this.props.s3FilesList.findIndex((data) => {
            return data.id === videoDetail.id;
        });
        this.setState({ editIndex: foundIndex, updatedTitle: videoDetail.title });
    };

    updateFile = (id) => {
        //   this.props.actions.updateS3File(id, this.state.updatedTitle)
        FileService.updateS3File(
            id,
            (document.getElementById("editTitle") as HTMLInputElement).value
        )
            .then(() => {
                this.props.actions.getS3FilesList();
                this.setState({ updatedTitle: null });
            })
            .catch((error) => { });
    };

    searchVideo = (e) => {
        this.setState({ searchVideo: e.target.value });
    };

    onSort = (sortedList, dropEvent, listInfo) => {
        let newArray = sortedList.map((data) => data.id);
        let fileId = listInfo.filter(
            (data) => data.id === dropEvent.currentTarget.dataset.id
        )[0].content.props.id;
        let newPosition = newArray.indexOf(dropEvent.currentTarget.dataset.id);
        FileService.updateS3FilePosition(fileId, newPosition).then(() => {
            this.props.actions.getS3FilesList();
        });
    };

    createListArray = () => {
        const { isAdmin } = this.state;
        let arrayData = [];
        if (this.state.videoFileList.length > 0) {
            arrayData =
                this.state.videoFileList.length > 0 &&
                this.state.videoFileList
                    .filter((videoData) =>
                        videoData.title
                            .toLowerCase()
                            .includes(this.state.searchVideo.toLowerCase())
                    )
                    .map((videoDetail, index) => {
                        return (
                            <div className="videoCol" id={videoDetail.id}>
                                {isAdmin && (
                                    <span
                                        onClick={() => this.deleteVideo(videoDetail.id)}
                                        className="deleteIcon"
                                    >
                                        X
                                    </span>
                                )}
                                <video height="240" src={videoDetail.s3Url} controls>
                                    Your browser does not support the video tag.
                                </video>
                                {this.state.editIndex == index &&
                                    this.state.updatedTitle !== null ? (
                                    <div className="videoBottomWrp">
                                        <div className="inputWrp">
                                            <input
                                                type="text"
                                                id="editTitle"
                                                defaultValue={this.state.updatedTitle}
                                            />
                                        </div>
                                        <button
                                            onClick={() => this.updateFile(videoDetail.id)}
                                            className="actionButton"
                                        >
                                            Enregistrer
                                        </button>
                                        <button
                                            onClick={() => this.setState({ editIndex: null })}
                                            className="actionButton"
                                        >
                                            Annuler
                                        </button>
                                    </div>
                                ) : (
                                    <div className="videoBottomWrp">
                                        <div>{videoDetail.title}</div>
                                        {isAdmin && (
                                            <button
                                                onClick={() => this.editVideoDetail(videoDetail)}
                                                className="actionButton"
                                            >
                                                Changer le titre
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    });
        }

        return arrayData;
    };
    render() {
        const { isAdmin } = this.state;
        var listInfo = this.createListArray();
        listInfo = listInfo.map((data) => {
            return { content: data };
        });
        return (
            <div className="aideMain">
                <div className="searhBarWraper">
                    <input
                        type="text"
                        placeholder="Rechercher une vidéo"
                        onChange={(e) => this.searchVideo(e)}
                    />
                    {this.state.selectedFile === null && isAdmin && (
                        <div className="customChooseFile">
                            <input type="file" onChange={this.onFileChange} />
                            Choisir une vidéo
                        </div>
                    )}
                    {this.state.selectedFile !== null && !this.state.uploading && (
                        <button className="bsearchButton" onClick={this.onFileUpload}>
                            Télécharger la vidéo
                        </button>
                    )}
                    {this.state.uploading && <div>Téléchargement...</div>}
                </div>
                {this.state.loadingList ? (
                    <Loader />
                ) : isAdmin ? (
                    <div className="videoWraper">
                        <DragSortableList
                            items={listInfo}
                            onSort={(sortedList, e) => this.onSort(sortedList, e, listInfo)}
                            type="grid"
                        />
                    </div>
                ) : (
                    <div className="videoWraper">{this.createListArray()}</div>
                )}
            </div>
        );
    }
}
function mapDispatchToProps(
    dispatch: Dispatch<ReducerState>
): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) };
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state;
}

export default connect(mapStateToProps, mapDispatchToProps)(AideDetail);

interface State {
    submitting: boolean;
    uploading: boolean;
    loadingList: boolean;
    selectedFile: File;
    editIndex: number;
    updatedTitle: string;
    searchVideo: string;
    isAdmin: boolean;
    videoFileList: any[];
}

type InjectedProps = MappedActionsProps & ReducerState;



// WEBPACK FOOTER //
// ./src/component/aide/aide-list.tsx